import React from 'react'

export default function Logo() {
	const darkBg = {
		backgroundColor: '#000000',
	};

  return (
    <section>
      <a className="anchor" id="logo"></a>
      <h2>Logo</h2>
      <p>The CME Group logo is the flagship of our brand identity - the principal visual reference for our audiences. For this reason, consistency of logo use is not only a design imperative, it's a business imperative.</p>
			<p>This 3-D version of the CME Group logo is optimized for use in high-quality offset printing, videos and broadcast applications. It may be used only by CME Group corporate communications and marketing. When high-quality reproduction is not available, the secondary two-color CME Group logo should be used.</p>
			<p>There are two versions of this 3-D logo, one with black type and one with white type.</p>

			<table className="table table--comfy table--dark">
			<thead>
				<tr>
					<th>Logo</th>
					<th>Logo Description</th>
					<th>Downloads</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className="text--center"><img src="images/CMEGroupLogo_BlackVersion.png" alt="CME Group logo black and white" className="push"/></td>
					<td className="text--center">Black and White Logo (Flat Globe)</td>
					<td className="text--center">
						<ul className="btn-group js-btn-group">
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_BlackVersion.png" download>Download PNG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_BlackVersion.jpg" download>Download JPG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_BlackVersion.eps" download>Download EPS</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_BlackVersion.svg" download>Download SVG</a>
							</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td className="text--center"><img src="images/CMEGroupLogo_Default.png" alt="CME Group logo flat" className="push"/></td>
					<td className="text--center">Color Logo</td>
					<td className="text--center">
						<ul className="btn-group js-btn-group">
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_Default.png" download>Download PNG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_Default.jpg" download>Download JPG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_Default.eps" download>Download EPS</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_Default.svg" download>Download SVG</a>
							</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td className="text--center" style={darkBg}><img src="images/CMEGroupLogo_DarkWithBlueGlobe.png" alt="CME Group logo dark with blue globe" className="push"/></td>
					<td className="text--center">White Logo (Blue Globe)</td>
					<td className="text--center">
						<ul className="btn-group js-btn-group">
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_DarkWithBlueGlobe.png" download>Download PNG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_DarkWithBlueGlobe.jpg" download>Download JPG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_DarkWithBlueGlobe.eps" download>Download EPS</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_DarkWithBlueGlobe.svg" download>Download SVG</a>
							</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td className="text--center" style={darkBg}><img src="images/CMEGroupLogo_DarkWithWhiteGlobe.png" alt="CME Group logo dark with white globe" className="push"/></td>
					<td className="text--center">White Logo (White Globe)</td>
					<td className="text--center">
						<ul className="btn-group js-btn-group btn-group-item--full-width">
							<li className="btn-group-item">
								<a className="btn btn--link" href="images/CMEGroupLogo_DarkWithWhiteGlobe.png" download>Download PNG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_DarkWithWhiteGlobe.jpg" download>Download JPG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_DarkWithWhiteGlobe.eps" download>Download EPS</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGroupLogo_DarkWithWhiteGlobe.svg" download>Download SVG</a>
							</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td className="text--center"><img src="images/CMEGlobe_Blue.png" alt="CME Group logo dark with white globe" className="push"/></td>
					<td className="text--center">CME Globe (Blue)</td>
					<td className="text--center">
						<ul className="btn-group js-btn-group btn-group-item--full-width">
							<li className="btn-group-item">
								<a className="btn btn--link" href="images/CMEGlobe_Blue.png" download>Download PNG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGlobe_Blue.jpg" download>Download JPG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGlobe_Blue.eps" download>Download EPS</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGlobe_Blue.svg" download>Download SVG</a>
							</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td className="text--center"><img src="images/CMEGlobe_Black.png" alt="CME Group logo dark with white globe" className="push"/></td>
					<td className="text--center">CME Globe (Black)</td>
					<td className="text--center">
						<ul className="btn-group js-btn-group btn-group-item--full-width">
							<li className="btn-group-item">
								<a className="btn btn--link" href="images/CMEGlobe_Black.png" download>Download PNG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGlobe_Black.jpg" download>Download JPG</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGlobe_Black.eps" download>Download EPS</a>
							</li>
							<li className="btn-group-item btn-group-item--full-width">
								<a className="btn btn--link" href="images/CMEGlobe_Black.svg" download>Download SVG</a>
							</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>

      <hr/>
    </section>
  )
}


// WEBPACK FOOTER //
// ./styleguide/components/sections/Logo.js